<template>
  <div v-if="!noTransferSource && !isLoading" class="red-transfer">
    <ModalWindow
      v-model:isOpen="isModalOpen"
      :backgroundOpacity="0.5"
      hideCloseIcon
    >
      <div class="red-transfer__options">
        <ProductButton
          v-for="item in products"
          class="red-transfer__options_item"
          :key="item.id"
          :icon="item.type"
          :title="item.title"
          :tailText="$currencyFormatter(item.amount)"
          @click="selectOption(item)"
        />
        <div @click="closeModal" class="red-transfer__options_cancel">
          {{ $t`Отмена` }}
        </div>
      </div>
    </ModalWindow>
    <CommonBanner
      :tagline="$t`Переведите остаток <br /> Ваших денег на другой счет`"
      type="neutral"
    />
    <div class="red-transfer__sources">
      <div class="red-transfer__sources_from">
        <ProductButton
          icon="red"
          title="Kaspi Red"
          :tailText="$currencyFormatter(redBalance, 'KZT', 2)"
        />
      </div>
      <div class="red-transfer__sources_icon">
        <div class="i-src-transfer"></div>
      </div>
      <div class="red-transfer__sources_to">
        <ProductButton
          v-if="selectedProduct"
          :icon="selectedProduct.type"
          :title="selectedProduct.title"
          :tailText="$currencyFormatter(selectedProduct.amount, 'KZT', 2)"
          @click="openModal"
        />
        <div v-else class="empty-transfer" @click="openModal">
          <div class="empty-transfer__text">
            {{ $t`Куда` }}
          </div>
          <div class="empty-transfer__icon">
            <div class="i-dots-red"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="red-transfer__hint">
      {{ $t`Комиссия 0 ₸` }}
    </div>
    <CommonButton v-if="selectedProduct" spaced @click="redirectToCloseSign">
      {{ $t`Перевести и закрыть Kaspi Red` }}
    </CommonButton>
  </div>
  <div v-else-if="!isLoading" class="no-products">
    <CommonBanner type="neutral" :tagline="noTransferText" />
    <CommonButton spaced @click="showClosestBranch">
      {{ $t`Ближайшее отделение Kaspi.kz` }}
    </CommonButton>
  </div>
</template>

<script>
import { getDetailsOnClose } from "@/api/close";
import CommonBanner from "@/components/shared/banner/CommonBanner";
import CommonButton from "@/components/shared/button/CommonButton";
import ModalWindow from "@/components/shared/modal/ModalWindow";
import ProductButton from "@/components/shared/button/ProductButton";

const products = {
  gold: "Kaspi Gold",
  depositkzt: "депозит",
};

export default {
  components: {
    ModalWindow,
    CommonBanner,
    CommonButton,
    ProductButton,
  },
  data() {
    return {
      isLoading: true,
      isModalOpen: false,
      isSmsModalOpen: false,
      isSelectable: false,
      selectedProduct: null,
      products: [],
      redBalance: null,
      noTransferSource: false,
    };
  },
  async created() {
    const response = await getDetailsOnClose();
    this.isLoading = false;
    this.redBalance = response.balance;
    this.products = response.products;
    if(this.products.length === 0){
      this.setNoTransferScreen();
    }
    if (this.products.length === 1) {
      this.selectedProduct = this.products[0];
     } else {
        this.setTransferScreen();
    }
  },
  computed: {
    noTransferText() {
      return this.$l10nformat(
        this
          .$t`Снимите остаток <br /> Ваших денег #AMOUNT# ₸ <br /> в любом отделении Kaspi.kz`,
        {
          AMOUNT: this.$route.query.balance,
        }
      );
    },
  },
  methods: {
    setNoTransferScreen() {
      this.$logAnalyticEvent("mybank_red_close_take_money_from_branch", {
        page_path: "/bank/closered/gotobranch",
      });
      this.noTransferSource = true;
    },
    setTransferScreen() {
      this.$logAnalyticEvent("mybank_red_close_transfer_screen", {
        page_path: "/bank/closered/transfer",
      });
      this.isSelectable = true;
    },
    async redirectToCloseSign() {
      this.$router.push({
        path: "/bank/red/close",
        query: {
          purpose: "Хочу уменьшить лимит",
          transfer: products[this.selectedProduct.type],
          amount: this.redBalance,
          id: this.selectedProduct.id,
        },
      });
    },
    openModal() {
      if (this.isSelectable) {
        this.isModalOpen = true;
      }
    },
    closeModal() {
      this.isModalOpen = false;
    },
    selectOption(option) {
      this.selectedProduct = option;
      this.closeModal();
    },
    showClosestBranch() {
      window.location.href = `${process.env.VUE_APP_ENV_URL}/maps/branches/?closest=true`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.red-transfer {
  font-family: Roboto-Regular;

  &__options {
    background-color: #f2f2f2;
    position: fixed;
    bottom: 0;

    &_item {
      margin-bottom: 1px;
    }

    &_cancel {
      color: $colorRed;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 63px;
    }
  }

  .empty-transfer {
    padding: 0 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 64px;
    background-color: white;

    &__text {
      color: #a8a8a8;
    }
  }

  &__hint {
    color: #a8a8a8;
    margin: 24px 0 5px;
    font-size: 13px;
    line-height: 14px;
  }

  &__sources {
    position: relative;
    margin-top: 10px;

    &_from {
      margin-bottom: 10px;
    }

    &_icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
    }
  }
}
</style>
